import { FieldModel } from '@cibo/core'
import { DataGridPro } from '@cibo/ui'
import { styled } from '@mui/material'

export const RollupStyledDataGridPro = styled(DataGridPro<Partial<FieldModel> & Record<string, any>>)(
  () => ({
    '.MuiDataGrid-cell': {
      padding: 0,
      position: 'relative',
    },
    '.MuiSelect': { boxShadow: 'none' },
    '.MuiDataGrid-pinnedRows': {
      backgroundColor: 'unset',
      boxShadow: 'unset',
    },
  })
)
